<template>
  <div class="tab-content" :id="id">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'TabContent',
  props: {
    id: {
      type: String,
      default: ''
    }
  }
}
</script>

